import React from 'react';

import { useDeleteCardsWithConfirmation } from '@vlabs/monokit/features/delete-cards';
import type { Card } from '@vlabs/api/point-api/model';
import { TableViewHead } from '@vlabs/monokit/shared/ui/table-view';
import type { TableViewHeadProps } from '@vlabs/monokit/shared/ui/table-view/head/types';

import { CardsBulkActions } from '../bulk-actions';

function CardListTableViewHead({ table, ...props }: TableViewHeadProps<Card>): React.JSX.Element {
  const selectedRows = table.getSelectedRowModel().rows;
  const deleteCardsHandler = useDeleteCardsWithConfirmation({
    cardIds: selectedRows
      .map(({ original }) => original.card_id)
      .filter((c) => c !== undefined),
  });
  return (
    <TableViewHead
      table={table}
      {...props}
    >
      {(table.getIsSomeRowsSelected() || table.getIsAllRowsSelected()) && (
        <CardsBulkActions
          indeterminate={table.getIsSomeRowsSelected()}
          onCancel={() => table.resetRowSelection()}
          onCheckboxClick={table.getToggleAllRowsSelectedHandler()}
          onDelete={() => {
            deleteCardsHandler?.();
          }}
          selectedCount={selectedRows.length}
        />
      )}
    </TableViewHead>
  );
}

export { CardListTableViewHead };
